export default __webpack_public_path__ + "static/media/productionIcon.2ea10529.png";